import { SxProps } from '@mui/material';

export const DrawerLoginFrameSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	height: 'auto',
	padding: '0px',
	position: 'fixed',
	bottom: 0,
	left: 0,
	right: 0,
	zIndex: 1000,
	borderTopLeftRadius: '10px',
	borderTopRightRadius: '10px',
};

export const DrawerLoginTitleSx: SxProps = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: 800,
	textAlign: 'left',
	width: '100%',
};

export const DrawerLoginContentSx: SxProps = {
	width: '100%',
	padding: '17px 30px 40px 30px',
};

export const DrawerLoginHeaderIconBackSx: SxProps = {
	fontSize: '24px',
	cursor: 'pointer',
	fill: '#2C2C2C',
	position: 'absolute',
	left: '30px',
	top: '21px',
};

export const DrawerLoginHeaderIconCloseSx: SxProps = {
	fontSize: '28px',
	cursor: 'pointer',
	fill: '#2C2C2C',
	position: 'absolute',
	right: '7px',
	top: '17px',
};
